import { clsx, Flex } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import useStyles from './AccordionButtons.styles';

type AccountAccordionButtonProps = {
  onClick: () => void;
  title: string;
  isCritical?: boolean;
  isGrey?: boolean;
  isDark?: boolean;
  isSecondary?: boolean;
  showArrow?: boolean;
};

function AccordionButton({
  onClick,
  title,
  isCritical = false,
  isGrey = false,
  isDark = false,
  isSecondary = false,
  showArrow = false,
}: AccountAccordionButtonProps) {
  const { classes, theme } = useStyles();
  const getColor = () => {
    if (isCritical) return theme.colors.red[3];
    if (isGrey) return theme.colors.gray2[6];
    if (isDark) return theme.white;
    return theme.colors.gray2[4];
  };

  return (
    <Button
      variant="text"
      className={clsx(classes.accordionButton, isSecondary && classes.isSecondary, [isGrey && 'isGrey', isDark && 'isDark'])}
      onClick={onClick}
    >
      <Flex w="100%" align="center" justify="flex-start">
        <Text
          data-test-id={dt.myAccount.transactionHistory.accordionButton}
          variant={isSecondary ? 'title-small' : 'title-medium'}
          color={getColor()}
        >
          {title}
        </Text>
        {showArrow && (
          <div className={classes.arrowIcon}>
            <IconChevronRight size={16} stroke={1.5} color={getColor()} />
          </div>
        )}
      </Flex>
      <hr className={classes.divider} />
    </Button>
  );
}

export default AccordionButton;
